import axios from 'axios';

export const ReceivedVoucherApi = {
  loadVouchers: filter =>
    axios.get(`api/public/info/kindergarten_voucher_child_po?filter=${filter}`)
};
